export const es_team= {
    title: 'Mi equipo',
    name: 'Nombre',
    email: 'Email',
    phone: 'Teléfono',
    password: 'Password',
    label_password: 'Si el campo permanece en blanco, la password no se cambiará',
    profession: 'Profesion',
    insert_new_team: 'Nuevos Colaboradores',
    new_member: 'Nuevos Colaboradores',
    new_member_btn:'Nuevo miembro',
    salva:'GUARDAR',
    remove:'ELIMINA',
    popover_incomeTeam_title: 'El equipo de esta operación',
    popover_incomeTeam_content: '<p>Ingrese, edite y elimine la información del equipo</p>',

    popover_myTeam_title: 'Equipo',
    popover_myTeam_content: '<p>Ingrese, edite y elimine la información del equipo</p>',
};